/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationDetailsQualificationsBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, isMeister: boolean };

export type OrganisationDetailsQualificationsBox_ModifyOrganisationMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OrganisationDetailsQualificationsBox_ModifyOrganisationMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, isMeister: boolean } } };

export const OrganisationDetailsQualificationsBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationDetailsQualificationsBox_ViewerOrganisation on ViewerOrganisation {
  id
  isMeister
}
    `;
export const OrganisationDetailsQualificationsBox_ModifyOrganisationDocument = gql`
    mutation OrganisationDetailsQualificationsBox_ModifyOrganisation($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      isMeister
    }
  }
}
    `;
export type OrganisationDetailsQualificationsBox_ModifyOrganisationMutationFn = Apollo.MutationFunction<OrganisationDetailsQualificationsBox_ModifyOrganisationMutation, OrganisationDetailsQualificationsBox_ModifyOrganisationMutationVariables>;

/**
 * __useOrganisationDetailsQualificationsBox_ModifyOrganisationMutation__
 *
 * To run a mutation, you first call `useOrganisationDetailsQualificationsBox_ModifyOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsQualificationsBox_ModifyOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDetailsQualificationsBoxModifyOrganisationMutation, { data, loading, error }] = useOrganisationDetailsQualificationsBox_ModifyOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationDetailsQualificationsBox_ModifyOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDetailsQualificationsBox_ModifyOrganisationMutation, OrganisationDetailsQualificationsBox_ModifyOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDetailsQualificationsBox_ModifyOrganisationMutation, OrganisationDetailsQualificationsBox_ModifyOrganisationMutationVariables>(OrganisationDetailsQualificationsBox_ModifyOrganisationDocument, options);
      }
export type OrganisationDetailsQualificationsBox_ModifyOrganisationMutationHookResult = ReturnType<typeof useOrganisationDetailsQualificationsBox_ModifyOrganisationMutation>;
export type OrganisationDetailsQualificationsBox_ModifyOrganisationMutationResult = Apollo.MutationResult<OrganisationDetailsQualificationsBox_ModifyOrganisationMutation>;
export type OrganisationDetailsQualificationsBox_ModifyOrganisationMutationOptions = Apollo.BaseMutationOptions<OrganisationDetailsQualificationsBox_ModifyOrganisationMutation, OrganisationDetailsQualificationsBox_ModifyOrganisationMutationVariables>;